
// Images parallax effect
// const parallaxElements = document.querySelectorAll(".sp-parallax-image");

// window.addEventListener("scroll", () => {
//   const scrollY = window.scrollY;

//   parallaxElements.forEach((element) => {
//     const speed = 0.08;

//     const rect = element.getBoundingClientRect();
//     const elementTop = rect.top + scrollY;

//     const movement = (scrollY - elementTop) * speed;

//     // @ts-ignore
//     element.style.transform = `translate3d(0, ${movement}px, 0)`;
//   });
// });
if (!document.documentElement.classList.contains("shopify-design-mode")) {
const parallaxElements = document.querySelectorAll(
  ".sp-parallax-image"
);

let ticking = false;

// function updateParallax() {
//   const scrollY = window.scrollY;

//   parallaxElements.forEach((element) => {
//     const speed = 0.08;

//     const rect = element.getBoundingClientRect();
//     const elementTop = rect.top + scrollY;

//     const movement =
//       (scrollY - elementTop) * speed;

//     // @ts-ignore
//     element.style.transform =
//       `translate3d(0, ${movement}px, 0) scale(1.08)`;
//   });

//   ticking = false;
// }

function updateParallax() {
  parallaxElements.forEach((element) => {
    const rect = element.getBoundingClientRect();

    const movement = Math.max(
      -80,
      Math.min(
        80,
        rect.top * -0.12
      )
    );
    // @ts-ignore
    element.style.transform =
      `translate3d(0, ${movement}px, 0) scale(1.08)`;
  });

  ticking = false;
}

window.addEventListener("scroll", () => {
  if (!ticking) {
    window.requestAnimationFrame(updateParallax);
    ticking = true;
  }
});
}

// in-view animation

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".sp-animate-reavel-up, .sp-animate-reavel-up-review, .sp-animate-form-card");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        // Element is visible
        if (entry.isIntersecting) {
        //   el.classList.remove("no-animation");

          // Entering from bottom
          if (entry.boundingClientRect.top > 0) {
            el.classList.add("in-view");
          }
          if (entry.boundingClientRect.top < 0) {
            el.classList.add("in-view");
            el.classList.add("no-animation");
          }
        } else {
          // Exited from top
          if (entry.boundingClientRect.top < 0) {
            el.classList.add("in-view");
            el.classList.add("no-animation");
          }

          // Exited from bottom
          if (entry.boundingClientRect.top > 0) {
            el.classList.remove("in-view");
            el.classList.remove("no-animation");
          }
        }
      });
    },
    {
      threshold: 0.15,
    }
  );

  sections.forEach((section) => {
    observer.observe(section);
  });



});


if (
  !document.documentElement.classList.contains(
    "shopify-design-mode"
  )
) {

  const images = document.querySelectorAll(
    ".sp-scale-scroll-image"
  );

  let ticking = false;

  function updateScaleImages() {

    images.forEach((image) => {

      const rect = image.getBoundingClientRect();

      const endPoint =
        window.innerHeight * 0.4;

      let progress =
        1 - (
          (rect.top - endPoint)
          / window.innerHeight
        );

      progress = Math.max(
        0,
        Math.min(progress, 1)
      );

      const scale =
        0.7 + progress * 0.3;

      // @ts-ignore
      image.style.transform =
        `scale(${scale})`;
    });

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateScaleImages);
      ticking = true;
    }
  }

  window.addEventListener(
    "scroll",
    requestTick,
    { passive: true }
  );

  window.addEventListener(
    "resize",
    requestTick
  );

  window.addEventListener(
    "load",
    updateScaleImages
  );

  updateScaleImages();
}

